import type { Metadata } from "next";
import { ServiceJsonLd, BreadcrumbJsonLd } from "@/components/JsonLd";

export const metadata: Metadata = {
  title: "AI & Chatbot Development Services",
  description:
    "Custom AI chatbots, RAG pipelines, automation workflows, and intelligent assistants. Built with OpenAI, Supabase, and modern AI frameworks. From $2,500.",
  openGraph: {
    title: "AI & Chatbot Development — Dev Cubix",
    description:
      "Custom AI chatbots, RAG pipelines, automation workflows. Built with OpenAI, Supabase, and modern AI frameworks.",
    url: "https://devcubix.com/services/ai",
  },
  alternates: {
    canonical: "https://devcubix.com/services/ai",
  },
};

export default function AIServiceLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      <ServiceJsonLd
        name="AI & Chatbot Development"
        description="Custom AI chatbots, RAG pipelines, automation workflows, and intelligent assistants built with OpenAI, Supabase, and modern AI frameworks."
        url="https://devcubix.com/services/ai"
        price="2500"
      />
      <BreadcrumbJsonLd
        items={[
          { name: "Home", url: "https://devcubix.com" },
          { name: "Services", url: "https://devcubix.com/services" },
          { name: "AI & Chatbots", url: "https://devcubix.com/services/ai" },
        ]}
      />
      {children}
    </>
  );
}
